import { Box, Grid } from "@mui/material";
import DashboardCardsUI from "./DashboardCardsUI";
import DashboardCardSkeleton from "./DashboardCardSkeleton";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import moment from "moment";
// import { newDashboardApi } from "../../../app/slices/mmtc/newDashboardSlice";
import DateSearchComponentForDashboard from "../../../components/customTable/DateSearchComponentForDashboard";
import { bajajDashboardApi } from "../../../app/slices/bajajDashboardSlice";

export default function BajajDashboard() {
  const dispatch = useDispatch();
  // const navigate = useNavigate();

  // ✅ Default 1-day range: Yesterday → Today
  // const [queryParams, setQueryParams] = useState({
  //   startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
  //   endDate: moment().format("YYYY-MM-DD"),
  // });
   const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });

  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };

  // ✅ Fetch dashboard data whenever date range changes
  useEffect(() => {

     if (queryParams.startDate && queryParams.endDate) {
       dispatch(bajajDashboardApi(queryParams));
  }
  }, [dispatch, queryParams]);

  // ✅ Redux selectors
  const sliceResponse = useSelector(
    (state) => state.bajajDashboard.bajajDashboard.data
  );
  const stateLoading = useSelector((state) => state.bajajDashboard.loading);

  // ✅ Card configurations (data-driven)
  const cards = [
    { title: "Bajaj Buy Total", value: `₹ ${sliceResponse?.bajajBuyTotals || 0}`, img: "/icons/bajaj.png" },
    { title: "Bajaj Sell Total", value: `₹ ${sliceResponse?.bajajSellTotals || 0}`, img: "/icons/bajaj.png" },
    { title: "Bajaj Redeem Total", value: `₹ ${sliceResponse?.bajajredeemTotals || 0}`, img: "/icons/bajaj.png" },

];

  return (
    <>
      <Box sx={{ mb: 2 }}>
        <DateSearchComponentForDashboard onSearch={handleSearch} />
      </Box>

      <Grid container spacing={2}>
        {cards.map((card, index) => (
          <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
            {!stateLoading ? (
              <DashboardCardsUI
                title={card.title}
                discription={card.value}
                img={card.img}
              />
            ) : (
              <DashboardCardSkeleton />
            )}
          </Grid>
        ))}
      </Grid>
    </>
  );
}






